export default {
  navigationBarTitleText: intl.get('commentList.title')
};
